import * as React from "react";
import { DateInput, Edit, required, SimpleForm, TextInput } from "react-admin";

export const TimePeriodEdit = (props: any) => {
  const validateTimePeriodEdit = (values) => {
    const errors: any = {};

    if (
      new Date(values.end).toLocaleDateString("sv-SE") <
      new Date(values.start).toLocaleDateString("sv-SE")
    ) {
      errors.end = `"End" can't be before "Start"`;
    }

    return errors;
  };

  return (
    <Edit {...props}>
      <SimpleForm
        variant="outlined"
        margin="none"
        validate={validateTimePeriodEdit}
      >
        <TextInput source="name" validate={[required()]} fullWidth />
        <DateInput
          source="start"
          defaultValue={new Date()}
          validate={[required()]}
        />
        <DateInput
          source="end"
          defaultValue={new Date()}
          validate={[required()]}
        />
      </SimpleForm>
    </Edit>
  );
};
